<script>
//https://forum-archive.vuejs.org/topic/141/global-variables-or-constant/5
export default {
  // backendPath: "http://172.28.26.212:3000/",//"http://localhost:3000/",
  // backendPath: "http://localhost:8888/",
  //Production
  backendPath: "https://ltcgroup.laotel.com:3000/",
  // backendPath: "https://115.84.121.196:80/",
  // backendPath: "http://115.84.121.158:3000/",
  token:null,
  userName:null,
  userIdentify:null,
  userObj:null,
  apiStatusOk:"OK",
  apiStatusNoOk:"NO_OK",
  apiStatusError:"ERROR",    
  surveyGroup:[],
  provinces:[],
  districts:[],
  selectedSurveyGroupName:null,
  //testSpeedLink was defined on 2023-06-02 to following request from testspeed team
  // testSpeedLink:"http://ltcmsisdn.laotel.com:3003/?redirectUrl=https://speed.laotel.com/?emp=@&msisdn="
  // http://172.28.26.221:8100/assets/behavioral/IMG00167.png
  testSpeedLink:"https://speed.laotel.com/?emp=@&msisdn=#",
  // http://ltcmsisdn.laotel.com:3003/?redirectUrl=http://speed.laotel.com/?msisdn=
  //https://speed.laotel.com/?emp=VT2576&msisdn=02055220199
  //


};
</script>
